import dayjs from 'dayjs';

import {
  DateRange as DateRangeBookablePeriods,
  NO_END,
  syncDayWithUTC,
} from '@ha/date';
import { DateRange as DayPickerDateRangeType } from '@ha/marketplace/feature-date-picker';

import { DateRange } from 'ha/modules/ContactAdvertiserForm/types';
import { DesiredDates } from 'ha/models/BookingDates/types';

export const calculateMultiUnitExclusions = (
  desiredDates: DesiredDates,
  bookablePeriods: DateRange[],
  exclusionList: DayPickerDateRangeType[],
): DayPickerDateRangeType[] => {
  if (!desiredDates?.startDate) {
    return [];
  }

  const desiredStart = dayjs(desiredDates.startDate);

  // find the longest bookable period that includes the start date
  let availableBookablePeriod: DateRangeBookablePeriods | undefined;
  bookablePeriods.forEach(bookablePeriod => {
    if (
      desiredStart.isBetween(
        bookablePeriod.from,
        bookablePeriod.to,
        'day',
        '[]',
      ) &&
      (!availableBookablePeriod ||
        dayjs(bookablePeriod.to).isAfter(availableBookablePeriod.to, 'day'))
    ) {
      availableBookablePeriod = bookablePeriod;
    }
  });

  // create exclusions based on last date of the available bookable period
  if (
    availableBookablePeriod?.to &&
    dayjs(availableBookablePeriod.to).isBefore(NO_END, 'day')
  ) {
    const endOfBookablePeriod = dayjs(availableBookablePeriod.to)
      .add(1, 'day')
      .toDate();

    return [
      ...exclusionList,
      {
        from: syncDayWithUTC(endOfBookablePeriod),
        to: syncDayWithUTC(dayjs(NO_END).toDate()),
      },
    ];
  }

  return [];
};
